import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import withStyles from 'material-ui-next/styles/withStyles'
import classNames from 'classnames'
import Icon from 'material-ui-next/Icon'
import IconButton from 'material-ui-next/IconButton'
import Input from 'material-ui-next/Input'
import breakpoints from '../../styles/breakpoints'
import { parseQ, mergeQs } from '../../utils'

const styles = theme => ({
  searchInput: {
    fontSize: 16,
    width: '250px',
    [`@media (max-width: ${breakpoints.xs})`]: {
      width: 'inherit',
    },
  },
  clear: {
    width: '30px',
    height: 30,
    position: 'relative',
    right: 30,
    marginRight: -30,
  },
  clearIcon: {
    color: theme.swapick.colors.neutral,
    fontSize: '20px',
  },
  ...theme.swapick.styles.toolbars,
})

class Search extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      searchString: parseQ(props.location),
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location !== nextProps.location) {
      const oldQ = parseQ(this.props.location)
      const nextQ = parseQ(nextProps.location)
      if (oldQ !== nextQ) {
        this.setState({ searchString: nextQ })
      }
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return (
  //     parseQ(this.props.location) !== parseQ(nextProps.location) ||
  //     this.state.searchString !== nextState.searchString
  //   )
  // }

  submitSearch = e => {
    e.preventDefault()
    const q = this.state.searchString
    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, { q })}`
    )
  }

  resetSearch = () => {
    if (parseQ(this.props.location) !== '') {
      this.props.history.push(
        `${this.props.location.pathname}?${mergeQs(this.props.location, {
          q: undefined,
        })}`
      )
    }
    this.setState({ searchString: '' })
  }

  handleOnChange = e => {
    this.setState({ searchString: e.target.value })
  }

  render() {
    const { searchString } = this.state
    const {
      classes,
      className,
      inputClassName,
      iconClasses = {},
      disableUnderline = false,
    } = this.props
    return (
      <form
        onSubmit={this.submitSearch}
        className={classNames(classes.toolbarGroup, className)}>
        <Input
          disableUnderline={disableUnderline}
          placeholder="Cerca"
          className={classNames(classes.searchInput, inputClassName)}
          value={searchString}
          onChange={this.handleOnChange}
        />
        <IconButton
          classes={{
            icon: classNames(classes.clearIcon, iconClasses.icon),
            root: classNames(classes.clear, iconClasses.root),
          }}
          onClick={this.resetSearch}
          aria-label="Cerca">
          {searchString ? <Icon>close</Icon> : <Icon>search</Icon>}
        </IconButton>
      </form>
    )
  }
}

export default withRouter(withStyles(styles)(Search))



// WEBPACK FOOTER //
// ./src/common/TopBar/Search.js